import 'slick-carousel';

let lightboxModal = null;
let lightboxCarousel = null;

export function initWallPostCarousels() {
  // Create lightbox modal if it doesn't exist
  if (!lightboxModal) {
    createLightboxModal();
  }

  // Attach click handlers to all image wrappers
  const imageWrappers = document.querySelectorAll('.images-wrapper');

  imageWrappers.forEach(wrapper => {
    const triggers = wrapper.querySelectorAll('.lightbox-trigger');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Get all images in this wrapper
        const images = Array.from(wrapper.querySelectorAll('.lightbox-trigger img')).map(img => ({
          src: img.getAttribute('data-full-src') || img.src,
          id: img.getAttribute('data-id')
        }));

        // Get clicked image index
        const clickedIndex = parseInt(trigger.getAttribute('data-index')) || 0;

        openLightbox(images, clickedIndex);
      });
    });
  });
}

function createLightboxModal() {
  lightboxModal = document.createElement('div');
  lightboxModal.className = 'wall-post-lightbox';
  lightboxModal.innerHTML = `
    <div class="lightbox-overlay"></div>
    <div class="lightbox-content">
      <button class="lightbox-close" aria-label="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.4091 12L3.70459 5.29549L5.29558 3.7045L12.0001 10.409L18.7046 3.7045L20.2956 5.29549L13.5911 12L20.2956 18.7045L18.7046 20.2955L12.0001 13.591L5.29558 20.2955L3.70459 18.7045L10.4091 12Z" fill="currentColor"/>
        </svg>
      </button>
      <div class="lightbox-carousel"></div>
    </div>
  `;

  document.body.appendChild(lightboxModal);

  // Event listeners
  lightboxModal.querySelector('.lightbox-close').addEventListener('click', closeLightbox);
  lightboxModal.querySelector('.lightbox-overlay').addEventListener('click', closeLightbox);

  // Close when clicking outside the carousel (on the content area)
  const lightboxContent = lightboxModal.querySelector('.lightbox-content');
  lightboxContent.addEventListener('click', (e) => {
    // Only close if clicking directly on the content area (not on carousel or its children)
    if (e.target === lightboxContent) {
      closeLightbox();
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (lightboxModal && lightboxModal.classList.contains('active')) {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    }
  });
}

function openLightbox(images, startIndex) {
  if (!lightboxModal) return;

  const carouselContainer = lightboxModal.querySelector('.lightbox-carousel');

  // Clear previous slides
  carouselContainer.innerHTML = '';

  // Add all images as slides
  images.forEach((image, index) => {
    const slide = document.createElement('div');
    slide.className = 'lightbox-slide';
    slide.innerHTML = `<img src="${image.src}" alt="" />`;
    carouselContainer.appendChild(slide);
  });

  // Show modal
  lightboxModal.classList.add('active');
  document.body.style.overflow = 'hidden';

  // Initialize Slick carousel
  if (typeof $ !== 'undefined' && $.fn.slick) {
    const $carousel = $(carouselContainer);

    $carousel.slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      initialSlide: startIndex,
      swipe: true,
      touchMove: true,
      variableWidth: false
    });

    lightboxCarousel = $carousel;

    // Create and add counter
    const counter = document.createElement('div');
    counter.className = 'lightbox-counter';
    lightboxModal.querySelector('.lightbox-content').appendChild(counter);

    // Update counter function
    const updateCounter = () => {
      const currentSlide = $carousel.slick('slickCurrentSlide') + 1;
      const totalSlides = $carousel.slick('getSlick').slideCount;
      counter.textContent = `${currentSlide} / ${totalSlides}`;
    };

    // Initial counter update
    updateCounter();

    // Update counter on slide change
    $carousel.on('afterChange', updateCounter);
  }
}

function closeLightbox() {
  if (!lightboxModal) return;

  // Destroy slick carousel
  if (lightboxCarousel && typeof $ !== 'undefined') {
    lightboxCarousel.slick('unslick');
    lightboxCarousel = null;
  }

  // Remove counter
  const counter = lightboxModal.querySelector('.lightbox-counter');
  if (counter) {
    counter.remove();
  }

  lightboxModal.classList.remove('active');
  document.body.style.overflow = '';
}

export function destroyWallPostCarousels() {
  if (lightboxModal) {
    closeLightbox();
  }
}
